import React, { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';

interface IDocumentLink {
  projectId: string;
  id: string;
  name: string;
}

const DocumentLink: FunctionComponent<IDocumentLink> = ({ name, projectId, id }) => {
  const history = useHistory();
  return (
    <span
      onClick={() => {
        history.push(`/projects/${projectId}/documents/${id}/details`);
      }}
    >
      {name}
    </span>
  );
};

export default DocumentLink;
